import OPE from 'js/on-page-editing';

import FactBox from 'components/fact-box/FactBox';

import { IAccordionListBlock } from 'source/NFR.types';

const AccordionListBlock: React.FC<IAccordionListBlock> = ({ list, title, onPageEditing }) => {
  return (
    <>
      {title && (
        <h2 className="accordion-list-block__title" {...OPE(onPageEditing?.title)}>
          {title}
        </h2>
      )}
      {list && (
        <ul className="accordion-list-block__list">
          {list?.map((accordionBlock, idx) => (
            <li key={accordionBlock.accordion.guid}>
              <FactBox {...accordionBlock} transparentRows topBorder={idx === 0 && !title} />
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

AccordionListBlock.displayName = 'AccordionListBlock';

export default AccordionListBlock;
